module.exports = __webpack_public_path__ + "hashed/101d26d25a492107b134316b1d2d7e09.svg";